import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { InputField } from '../InputField';
import { formatPhoneNumber } from '@/utils/format';
import { type WithFormControlProps } from '../WithFormControl';

type ControlProps<T extends FieldValues> = Pick<UseControllerProps<T>, 'control' | 'name' | 'rules' | 'disabled'>;

type InputCpfCnpjProps<T extends FieldValues> = ControlProps<T> & {
  label: string;
  withoutFloating?: boolean;
  rootProps?: WithFormControlProps;
};

export function InputPhone<T extends FieldValues>({ name, control, label, withoutFloating, rootProps }: InputCpfCnpjProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...props } }) => (
        <InputField
          withoutFloating={withoutFloating}
          label={label}
          rootProps={rootProps}
          onChange={e => {
            const { value } = e.target;
            e.target.value = formatPhoneNumber(value);
            onChange(e);
          }}
          maxLength={19}
          {...props}
        />
      )}
    />
  );
}
